module.exports = __webpack_public_path__ + "build/desktop/a/img/icon_point.c21a9cda439922850824f4381dbe7b27.svg";